export enum ImageTextAlignment {
  Left = 'left',
  Center = 'center',
  Right = 'right',
}
